import SignUpForm from 'Components/UserAuth/SignUpForm'
import '../css/SignUp.css'

const SignUp = () => {
  return <SignUpForm show={true} />
}

export default SignUp
